/* global angular */

(function () {
  'use strict';

  angular.module('wsLrs.directives').controller('UploadImageCtrl', ['$scope', 'Upload', 'Api', function ($scope, Upload, Api) {
    $scope.uploadImage = function () {
      // In case they didn't select anything here.
      if (!$scope.file) {
        return;
      }
      $scope.uploadImageError = null;
      $scope.uploading = true;
      Upload.upload({
        url: Api.url($scope.uploadUrl),
        data: {
          myObj: $scope.myModelObj
        },
        file: $scope.file
      }).then(function (response) {
        var imageUrl = response.headers("Location");
        $scope.uploading = false;
        $scope.uploadImageModal.close(imageUrl);
      }, function (response) {
        $scope.uploading = false;
        $scope.uploadImageError = response.data.message;
      });
    };
    $scope.cancelUpload = function () {
      $scope.uploadImageModal.dismiss('cancel');
    };
    $scope.onFileSelect = function ($files) {
      // We always get an array despite the fact the control is for a single file
      $scope.file = $files[0];
    };
  }]);
})();
